<template>
  <div>
    <kendo-panelbar ref="panelbar">
      <div class="panel-section">
        <p>{{ Heading }}</p>
        <p v-if="options != null">{{ Title1 }} {{ Value1 }}</p>
        <p v-else>{{ Title1 }} {{ Value1 }}</p>
        <p>{{ Title2 }} {{ Value2 }}</p>
        <p v-if="options != null && !customSettingFlag">{{ Title3 }} {{ isEnable }}</p>
        <p v-if="options == null && !customSettingFlag">{{ Title3 }} {{ Value3 }}%</p>
        <p v-if="customSettingFlag">{{ Title3 }} {{ customSettingToggleValue }}</p>
        <slot></slot>
      </div>
    </kendo-panelbar>
  </div>
</template>
<script lang="ts">
import { PanelBar } from "@progress/kendo-layout-vue-wrapper";
import Toggle from "./Toggle.vue";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "Accordion",
  components: {
    "kendo-panelbar": PanelBar,
    Toggle
  },
  props: {
    Heading: null as unknown as PropType<any | null>,
    Title1: null,
    Title2: null,
    Title3: null,
    Value1: null,
    Value2: null,
    Value3: null,
    options: null,
    isEnable: null,
    customSettingToggleValue: null,
    customSettingFlag: null,
    defaultExpanded: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.defaultExpanded) {
      const panelBar = (this.$refs.panelbar as any)?.kendoWidget();
      panelBar?.expand(".panel-section", false);
    }
  }
});
</script>
<style scoped>
p {
  color: white !important;
}
.k-icon {
  font-size: 24px !important;
}
.col-2 {
  max-width: 13.666667% !important;
}
</style>
